import React from 'react';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
// @ts-ignore
import styles from './NCZIWizardSteps.module.scss';
import Text from '../../../../../Components/Base/Text/Text';
import useTranslation from '../../../../../Hooks/useTranslation';

interface Props {
	onContinue: () => void;
}

const NCZIWizardRequirements: React.FC<Props> = ({ onContinue }) => {
	const { t } = useTranslation();
	return (
		<div className={styles.wrapper}>
			<Text tx='nczi.wizardRequirements.title' className={styles.title} />
			<ol>
				<li>{t('nczi.wizardRequirements.list.item1')}</li>
				<li>{t('nczi.wizardRequirements.list.item2')}</li>
				<li>{t('nczi.wizardRequirements.list.item3')}</li>
			</ol>
			<Button
				theme={Theme.GREEN}
				onClick={onContinue}
				title='base.shared.continue'
				className={styles.button}
			/>
		</div>
	);
};

export default NCZIWizardRequirements;
